// Tiny i18n. Looks up dotted path. Fallback to key. Locale from
// profile.locale > browser > 'de'. No interpolation lib — use replace() inline.

import { useQuery } from '@tanstack/react-query'

const STRINGS = {
  de: {
    nav: { heute: 'Heute', board: 'Board', daten: 'Daten', mehr: 'Mehr' },
    actions: {
      add: '+ Add', save: 'Save', cancel: 'Cancel', delete: 'Löschen',
      reload: 'Reload', skip: 'Skip', back: 'Back', next: 'Next', start: 'Start',
      logout: 'Logout',
    },
    auth: {
      login: 'Login', signup: 'Signup',
      magic: 'Send Magic Link', pw: 'Sign in',
      switch_to_pw: 'use password instead',
      switch_to_magic: 'use magic link instead',
      no_account: 'Noch keinen Account?',
      have_account: 'Schon ein Account?',
    },
    sections: {
      heute: 'Heute', srank: 'S-Rank', streak: 'Streak',
      macrobot: 'Macrobot', caffeine: 'Koffein', supplements: 'Supplements',
      reflection: 'Reflection', quests: 'Quests', kanban: 'Kanban',
      module: 'Module', account: 'Account',
    },
    empty: {
      heute: 'Kein Modul aktiv für diesen Tab. Öffne Mehr → Module.',
      board: 'Aktiviere Quests oder Kanban in Mehr → Module.',
    },
  },
  en: {
    nav: { heute: 'Today', board: 'Board', daten: 'Data', mehr: 'More' },
    actions: {
      add: '+ Add', save: 'Save', cancel: 'Cancel', delete: 'Delete',
      reload: 'Reload', skip: 'Skip', back: 'Back', next: 'Next', start: 'Start',
      logout: 'Logout',
    },
    auth: {
      login: 'Login', signup: 'Sign up',
      magic: 'Send Magic Link', pw: 'Sign in',
      switch_to_pw: 'use password instead',
      switch_to_magic: 'use magic link instead',
      no_account: "Don't have an account?",
      have_account: 'Already have an account?',
    },
    sections: {
      heute: 'Today', srank: 'S-Rank', streak: 'Streak',
      macrobot: 'Macros', caffeine: 'Caffeine', supplements: 'Supplements',
      reflection: 'Reflection', quests: 'Quests', kanban: 'Kanban',
      module: 'Modules', account: 'Account',
    },
    empty: {
      heute: 'No module active. Open More → Modules.',
      board: 'Enable Quests or Kanban in More → Modules.',
    },
  },
}

function detectLocale(profileLocale) {
  if (profileLocale && STRINGS[profileLocale]) return profileLocale
  const nav = (navigator.language || 'de').slice(0, 2).toLowerCase()
  return STRINGS[nav] ? nav : 'de'
}

export function useT(profileLocale) {
  const locale = detectLocale(profileLocale)
  const dict = STRINGS[locale]
  return (path, fallback) => {
    const parts = path.split('.')
    let cur = dict
    for (const p of parts) {
      cur = cur?.[p]
      if (cur == null) return fallback ?? path
    }
    return cur
  }
}
